import React, { useEffect } from "react";
import Quiz3 from '../components/Quiz3';
import Navbar from '../components/Navbar';
import { landingPageNavItems } from '../data/mockData';
import { logEvent, logPageView } from "../utils/analytics";

const QuizPage = () => {
  useEffect(() => {
    // Track quiz page view
    logPageView('/quiz3');
    logEvent('Quiz', 'ViewContent', 'Quiz Step 3');
  }, []);

  const handleQuizInteraction = (questionId, answer) => {
    logEvent('Quiz', 'Answer', `Question ${questionId}`, answer);
  };

  const handleQuizCompletion = () => {
    logEvent('Quiz', 'Complete', 'Quiz Finished');
  };

  return (
    <div className="min-h-screen bg-[#EDE3DD] p-2 md:p-8">
      <Navbar navItems={[]} />
      <Quiz3 
        onQuizInteraction={handleQuizInteraction}
        onQuizComplete={handleQuizCompletion}
      />
    </div>
  );
};

export default QuizPage;